/// <amd-module name="Tfs/Frame/Components/Profile/Profile" />
import * as React from "react";
import * as Resources from "Tfs/Frame/Resources";

import { VssPersona } from "VSSUI/VssPersona";

import { getIdentityImageUrl, IdentityImageSize } from "VSS/Platform/Identity";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IVssPageService } from "VSS/Platform/Page";

import { getMenuItems } from "VSS/Features/PlatformUI/ContributedMenu";
import { ExpandableContainer, IExpandable } from "VSSUI/Expandable";
import { ContextualMenu } from "VSSUI/Menu";
import { Location } from "VSSUI/Utilities/Position";

export class Profile extends VssComponent<{}> {
    private displayName: string | undefined;
    private imageUrl: string | undefined;

    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        const pageService = context.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = pageService.getData();

        if (pageData && pageData.user) {
            this.displayName = pageData.user.displayName;
            this.imageUrl = getIdentityImageUrl(context.pageContext, pageData.user, IdentityImageSize.medium);
        }
    }

    public render(): JSX.Element {
        return (
            <ExpandableContainer
                className="navigation-profile-menu commandbar-item commandbar-icon cursor-pointer flex-row flex-noshrink justify-center"
                expandableId="profile-menu"
                role="menuitem"
                renderCallout={this.renderDropdown}
            >
                <VssPersona
                    imgAltText={Resources.ManageUserSettings}
                    size="small"
                    suppressPersonaCard={true}
                    identityDetailsProvider={{
                        getIdentityImageUrl: (size: number): string | undefined => {
                            return this.imageUrl;
                        },

                        getDisplayName: (): string => {
                            return this.displayName || "";
                        }
                    }}
                />
            </ExpandableContainer>
        );
    }

    private renderDropdown = (dropdown: IExpandable, id: string, element: HTMLElement): JSX.Element => {
        return (
            <ContextualMenu
                onDismiss={dropdown.collapse}
                anchorElement={element}
                anchorOrigin={{ horizontal: Location.end, vertical: Location.end }}
                menuProps={{
                    id,
                    items: getMenuItems(this.context.pageContext, "ms.vss-tfs-web.profile-menu")
                }}
                menuOrigin={{ horizontal: Location.end, vertical: Location.start }}
            />
        );
    };
}

VssComponent.register("ms.vss-tfs-web.profile", Profile);
